// Image Fit Types
var UitkImageFitMap = [['cover', 'fit-cover'], ['contain', 'fit-contain']];
var UitkImageFits = new Map(UitkImageFitMap);
// Roundcorner Types
var UitkRoundcornerPropMap = [['all', 'all'], ['max', 'max'], ['startstart', 'startstart'], ['startend', 'startend'], ['endstart', 'endstart'], ['endend', 'endend']];
var UitkRoundcorners = new Map(UitkRoundcornerPropMap);
export { UitkImageFits, UitkRoundcorners };